module.exports = __webpack_public_path__ + "img/yida.6fea01fb.jpg";